import { Directive, ElementRef, HostBinding } from '@angular/core';
import { DndDraggableDirective } from '@app/shared/modules/dnd/directives/dnd-draggable.directive';

@Directive({
  selector: '[rkDragImageRef]',
})
export class DragImageRefDirective {
  @HostBinding('style.position')
  position = 'fixed';

  constructor(parent: DndDraggableDirective, elementRef: ElementRef) {
    parent.registerDragImage(elementRef);
  }
}
